import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown';

const propTypes = {
  dropdownProps: PropTypes.object,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

const defaultProps = {
  dropdownProps: null,
};

const ReduxFormDropdown = props => {
  const { input, meta } = props;
  const { touched, invalid, asyncValidating, error, active } = meta;
  const validate = !active && touched && !asyncValidating;
  const isInvalid = validate && invalid;
  const onDropdownChange = (event, index, value) => input.onChange(value);
  const onClose = () => {
    const onCloseProp = props.dropdownProps && props.dropdownProps.onClose;

    input.onBlur(input.value);

    if (onCloseProp) {
      onCloseProp();
    }
  };

  return (
    <Dropdown
      {...props.dropdownProps}
      name={input.name}
      onChange={onDropdownChange}
      onClose={onClose}
      errorMsg={isInvalid ? error : null}
      value={input.value}
    />
  );
};

ReduxFormDropdown.propTypes = propTypes;
ReduxFormDropdown.defaultProps = defaultProps;

export default ReduxFormDropdown;



// WEBPACK FOOTER //
// ../ui-components/components/ReduxFormDropdown/index.jsx